import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { authMe, authLogout, startGoogleLogin } from '../lib/authApi';

const AuthCtx = createContext({ user: null, loading: true, refresh: () => {}, logout: async () => {}, login: () => {} });

export const PublicAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    try {
      const u = await authMe();
      setUser(u);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = async () => {
    try { await authLogout(); } catch {}
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, refresh, logout, login: startGoogleLogin }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const usePublicAuth = () => useContext(AuthCtx);
